import { createWebHistory, createRouter } from 'vue-router';

const Login = () => import('@/views/Login');
const Index = () => import('@/views/Index');
const BasicLayout = () => import('@/layouts/BasicLayout.vue');
const TouchList = () => import('@/views/touch/TouchList.vue');
const TouchDetails = () => import('@/views/touch/TouchDetails.vue');
const DataStatistics = () => import('@/views/data/DataStatistics.vue');
const BusinessCategory = () => import('@/views/system/BusinessCategory.vue');
const PrestoreCode = () => import('@/views/touch/PrestoreCode.vue');
const AiMateList = () => import('@/views/mate/AiMateList.vue');
const AiMateDetails = () => import('@/views/mate/AiMatedetails.vue');
const SystemParams = () => import('@/views/system/SystemParams.vue');

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'Index',
        component: Index
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/basic',
        name: 'BasicLayout',
        component: BasicLayout,
        children: [
            {
                path: 'touchList',
                name: 'TouchList',
                component: TouchList
            },
            {
                path: 'touchDetails',
                name: 'TouchDetails',
                component: TouchDetails
            },
            {
                path: 'data',
                name: 'data',
                component: DataStatistics
            },
            {
                path: 'business',
                name: 'business',
                component: BusinessCategory
            },
            {
                path: 'prestoreCode',
                name: 'prestoreCode',
                component: PrestoreCode
            },
            {
                path: 'mate/list',
                name: 'mateList',
                component: AiMateList
            },
            {
                path: 'mate/details',
                name: 'mateDetails',
                component: AiMateDetails
            },
            {
                path: 'system/params',
                name: 'systemParams',
                component: SystemParams
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory('admin'),
    routes
});

export default router;
